import styled from 'styled-components';

import { ReactComponent as HomeHelp } from 'assets/images/home-help.svg';
import { ReactComponent as HomeProfile } from 'assets/images/home-profile.svg';

export const Container = styled.section`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const IconProfile = styled(HomeProfile)`
  color: ${({ theme }) => theme.desktop.header.color};
  width: 28px;
  height: 28px;
`;
export const IconHelp = styled(HomeHelp)`
  color: ${({ theme }) => theme.desktop.header.color};
  width: 26px;
  height: 26px;
`;

export const Icon: any = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px 12px;
`;

Icon.Label = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.desktop.header.color};
  padding: 5px 0;
`;

Icon.Flag = styled.div`
  height: 60px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 5px 12px;

  & img {
    width: 60px;
    height: 60px;
    vertical-align: middle;
    object-fit: contain;
  }
`;
